import React from "react";
import { Outlet, Link, useLocation } from "react-router-dom";
import "./PublicLayout.css";

function PublicLayout() {
  const location = useLocation();

  return (
    <div className="protected-layout">
      <nav className="navbar">
        <div className="navbar-brand">
          <Link to="/">OSRS Snakes & Ladders</Link>
        </div>

        <div className="navbar-links">
          {/* Guide link - active state check is a nice touch */}
          <Link
            to="/guide"
            className={`nav-link ${location.pathname === "/guide" ? "active" : ""}`}
          >
            Guide
          </Link>

          <Link to="/games/spectate" className="btn-secondary">
            Spectate
          </Link>

          {/* Optional: Add back the Login link if you want it visible on all public pages */}
          {/* <Link to="/" className="public-auth-link">Login</Link> */}
        </div>
      </nav>

      <main className="public-content">
        <Outlet />
      </main>
    </div>
  );
}

export default PublicLayout;
